<template>
  <el-select
    v-model="_model"
    clearable
    filterable
    remote
    @change="onChangeUser"
    @clear="onClear"
    @focus="onFocusQueryUser"
    :loading-text="$t('pages.wording.querying')"
    :no-data-text="$t('pages.wording.noDataFind')"
    :placeholder="$t('pages.wording.placeholderUserQuery')"
    :remote-method="onQueryEmpUser"
    :loading="queryEmpUserIsLoading"
  >
    <el-option
      v-for="item in userList"
      :key="item.code"
      :label="`${item.name} (${item.account ?? item.code}) `"
      :value="item[keyName]"
    >
    </el-option>
  </el-select>
</template>
<script>
import { api } from "@/utils/api.js"
import debounce from "lodash/debounce"

export default {
  name: "QueryEmpUser",
  data() {
    return {
      queryEmpUserIsLoading: false,
      userList: [],
    }
  },
  props: {
    model: {
      type: String,
      default: "",
      require: true,
    },
    keyName: {
      type: String,
      default: "",
      require: true,
    },
  },
  methods: {
    onQueryEmpUser(query) {
      if (!query) {
        return
      }
      this.queryEmpUserIsLoading = true
      this.queryEmpUser(query)
    },
    queryEmpUser: debounce(async function (query) {
      const vueInstance = this
      try {
        const { data } = await api.apiSearchEmpUser({ params: { query: query } })
        vueInstance.userList = data
        vueInstance.queryEmpUserIsLoading = false
      } catch (e) {
        vueInstance.queryEmpUserIsLoading = false
        console.error(e)
      }
    }, 500),
    onChangeUser(value) {
      this.$emit("change", value)
    },
    onFocusQueryUser() {
      this.userList = null
    },
    onClear() {
      this.$emit("clear")
    },
  },
  computed: {
    _model: {
      get() {
        return this.model
      },
      set(value) {
        this.$emit("update:model", value)
      },
    },
  },
}
</script>
